import {
  SPOR_TOTO_SLIP_TOGGLE,
  SPOR_TOTO_SLIP_RESET,
  SET_SPOR_TOTO_SLIP_DATA
} from 'Store/constants';

export const toggleSporTotoSlip = () => dispatch => {
  dispatch({
    type: SPOR_TOTO_SLIP_TOGGLE
  });
};

export const setSporTotoSlipData = sporTotoEvents => dispatch => {
  dispatch({
    type: SET_SPOR_TOTO_SLIP_DATA,
    payload: sporTotoEvents
  });
};

export const resetSporTotoSlip = () => dispatch => {
  dispatch({
    type: SPOR_TOTO_SLIP_RESET
  });
};
